const C_SITE_BASE_PATH = 'site/'

export enum SiteApiPath {
  /**
   * 获取客户端字典配置
   */
  Configs = 'site/configs',
  /**
   * 功能开关设置等
   */
  Settings = 'site/settings',

}
